import { useEffect, useState } from "react";
import { useRouter } from "next/router";

import FullScreenLoader from "@/components/Loaders/FullScreenLoader/Loader";
import { Auth } from "@/components/Auth/Auth";
import Brand from "@/components/Typography/Brand/Brand";
import { isEmptyObject } from "@/utils/object";
import { useAuth } from "@/context/AuthContext";
import { useAnalytics } from "@/context/GoogleAnalyticsContext";
import styles from "@/styles/pages/Home.module.scss";

const Home = () => {
  const router = useRouter();
  const { authLoading, user } = useAuth();
  const { sendAnalyticsRecord } = useAnalytics();
  const [isRedirecting, setIsRedirecting] = useState(false);

  const [isReturningFromSocial, setIsReturningFromSocial] = useState(() => {
    if (typeof window !== 'undefined') {
      return sessionStorage.getItem('socialAuthInProgress') === 'true';
    }
    return false;
  });

  useEffect(() => {
    router.prefetch('/generator');
  }, [router]);

  useEffect(() => {
    if (!authLoading && isEmptyObject(user) && isReturningFromSocial) {
      setIsReturningFromSocial(false);
      sessionStorage.removeItem('socialAuthInProgress');
    }
  }, [authLoading, user, isReturningFromSocial]);


  useEffect(() => {
    if (!authLoading && !isEmptyObject(user) && user.email && user.id) {
      setIsRedirecting(true);

      sessionStorage.removeItem('socialAuthInProgress');

      router.push("/generator");
    }
  }, [user, authLoading, router]);

  useEffect(() => {
    sendAnalyticsRecord("page_view", {
      page_location: window.location.href,
      page_title: document?.title,
      page_name: "Home",
    });
  }, []);


  if (!authLoading && !isEmptyObject(user) && user.email && user.id) {
    return <FullScreenLoader isLoading={true} />;
  }

  return authLoading || isRedirecting || isReturningFromSocial ? (
    <FullScreenLoader isLoading={true} />
  ) : (
    <div className={styles.homeContent}>
      <div className={styles.overlay}>
        <div className={styles.leftContainer}></div>

        <div className={styles.rightContainer}>
          <Brand variant="large" />
          <div className={styles.authContainer}>
            <Auth />
          </div>
        </div>
      </div>
      <div className={styles.splashContainer}></div>
    </div>
  );
};

export default Home;
